import { useMutation, useQueryClient } from '@tanstack/react-query'
import Cookies from 'js-cookie'
import { readSavedQueries, type SavedSearchConfig, type SavedSearchQuery } from '@/lib/saved-search'

export function useSaveSearchQuery(config: SavedSearchConfig) {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (newQuery: SavedSearchQuery) => {
      const savedQueries = readSavedQueries(config)

      // 同名のクエリがあれば更新、なければ追加
      const existingIndex = savedQueries.findIndex((q) => q.name === newQuery.name)
      if (existingIndex >= 0) {
        savedQueries[existingIndex] = newQuery
      } else {
        savedQueries.push(newQuery)
      }

      Cookies.set(config.cookieKey, JSON.stringify(savedQueries), config.cookieOptions)
      return savedQueries
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: config.queryKey() })
    },
  })
}
